<template>
  <div class="dialog-wrap">

    <el-dialog title="分值管理"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="70%">
      <div class="title-wrap">
        <div class="input-box">
          <span>试卷名称：</span>
          <p>{{paper.name}}</p>
        </div>
        <span>总分值：{{conputendSocre}}分</span>
      </div>
      <el-table class="table"
                max-height="600"
                :data="itemList"
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="id"
                         align="center"
                         label="ID"
                         width="120">
        </el-table-column>
        <el-table-column label="题干"
                         min-width="180">
          <template slot-scope="scope">
            <div class="material"
                 v-if="scope.row.material">
              <span v-html="scope.row.rich_text"></span>
            </div>
            <div class="material"
                 v-if="!scope.row.material">
              <span v-html="scope.row.description"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="题型"
                         prop="answer_type_text"
                         align="center"
                         width="120">
        </el-table-column>
        <!-- <el-table-column label="题目ID"
                         prop="id"
                         align="center"
                         width="120">
        </el-table-column> -->
        <el-table-column abel="在线状态"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status===1">已上线</span>
            <span v-if="scope.row.status===0">已上线</span>
          </template>
        </el-table-column>
        <el-table-column label="分值"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <div v-if="!scope.row.material">
              <el-input v-model="scope.row.score"
                        placeholder="请输入分值"
                        @change="change(scope.row)"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop=""
                         align="center"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <div class="up-down"
                 v-if="!scope.row.material">
              <div>
                <el-button type="success"
                           :disabled="isFirst(scope.row)"
                           icon="el-icon-top"
                           @click="moveUp(scope.row)"
                           circle></el-button>
              </div>
              <div>
                <el-button type="info"
                           :disabled="isLast(scope.row)"
                           icon="el-icon-bottom"
                           @click="moveDown(scope.row)"
                           circle></el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  measureScrollDetail,
  examItemList,
  examItemCreated,
  examItemDete,
  measureScrollPut,
  examItemPut,
  examMorePut,
} from '@/api/course'
let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    paperId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      itemList: [],
      paper: {},
    }
  },
  computed: {
    conputendSocre() {
      let score = 0
      this.itemList.forEach((item, index) => {
        if (!item.children) {
          score += Number(item.score || 0)
        }
        if (item.children) {
          item.children.forEach((subItem) => {
            score += Number(subItem.score || 0)
          })
        }
      })
      return score
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchPaperInfo()
        this.fetchPaperItemList()
      }
    },
  },
  created() {},
  methods: {
    // 试卷基本信息
    fetchPaperInfo() {
      if (!this.paperId) {
        return
      }
      measureScrollDetail({ id: this.paperId }).then((res) => {
        if (res) {
          this.paper = res
        }
      })
    },
    //试卷题目列表
    fetchPaperItemList() {
      if (!this.paperId) {
        return
      }
      examItemList({ measure_scroll_id: this.paperId }).then((res) => {
        this.itemList = res.list || []
        console.log('this.itemList', this.itemList)
      })
    },
    change(val) {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemPut({ id: val.id, score: val.score }).then((res) => {})
      }, TimerTime)
    },
    // 判断是否是该组的第一个元素
    // 递归查找节点的父节点和兄弟节点
    findParentAndSiblings(nodeId, nodes, parent = null) {
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (node.id === nodeId) {
          return { parent, siblings: nodes, index: i }
        }
        if (node.children) {
          const result = this.findParentAndSiblings(nodeId, node.children, node)
          if (result) {
            return result
          }
        }
      }
      return null
    },

    // 判断是否是该组的第一个元素
    isFirst(row) {
      const { siblings, index } = this.findParentAndSiblings(
        row.id,
        this.itemList
      )
      return index === 0
    },
    // 判断是否为子级节点
    isChildNode(row) {
      // 递归检查当前节点是否在某个父节点的children数组里
      const result = this.findParentAndSiblings(row.id, this.itemList)
      return result.parent !== null
    },

    // 判断是否是该组的最后一个元素
    isLast(row) {
      const { siblings, index } = this.findParentAndSiblings(
        row.id,
        this.itemList
      )
      console.log('indexs', index)
      return index === siblings.length - 1
    },
    handleClose() {
      this.$emit('close')
    },
    // 上移逻辑
    moveUp(row) {
      const { siblings, index } = this.findParentAndSiblings(
        row.id,
        this.itemList
      )
      if (index > 0) {
        const temp = siblings[index]
        siblings.splice(index, 1)
        siblings.splice(index - 1, 0, temp)
      }

      if (this.isChildNode(row)) {
        let changeData = { rows: [] }
        this.itemList.map((item) => {
          if (item.children) {
            item.children.map((v, index) => {
              changeData.rows.push({
                id: v.id,
                sort: index,
              })
            })
          }
        })
        this.handleSortChange(changeData)
      } else {
        let parentData = { rows: [] }
        this.itemList.map((it, k) => {
          parentData.rows.push({
            id: it.id,
            sort: k,
          })
        })
        this.handleSortChange(parentData)
      }
    },

    // 下移逻辑
    moveDown(row) {
      const { siblings, index } = this.findParentAndSiblings(
        row.id,
        this.itemList
      )
      if (index < siblings.length - 1) {
        const temp = siblings[index]
        siblings.splice(index, 1)
        siblings.splice(index + 1, 0, temp)
      }
      if (this.isChildNode(row)) {
        let changeData = { rows: [] }
        this.itemList.map((item) => {
          if (item.children) {
            item.children.map((v, index) => {
              changeData.rows.push({
                id: v.id,
                sort: index,
              })
            })
          }
        })
        this.handleSortChange(changeData)
      } else {
        let parentData = { rows: [] }
        this.itemList.map((it, k) => {
          parentData.rows.push({
            id: it.id,
            sort: k,
          })
        })
        this.handleSortChange(parentData)
      }
    },
    handleSortChange(data) {
      examMorePut(data)
        .then((res) => {
          this.$emit('submitUpta')
        })
        .catch((error) => {
          this.$message.error('题目排序更新异常')
          console.log('error: ', error)
        })
    },
  },
}
</script>

<style scoped lang="less">
.dialog-wrap {
  .table {
    margin-top: 10px;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .material {
    max-height: 40px;
    overflow: hidden;
    overflow-y: auto;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .input-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-input {
      width: 400px;
    }
  }
  .title-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .up-down {
    padding: 0 20px;
    justify-content: space-around;
    display: flex;
    flex-direction: row;
  }
}
</style>
